'use client';

import { UIComponent } from '@/components/core/components';
import { Trans } from '@lingui/react/macro';
import { CategoryConstantType, CategoryType, FeedType, ProductType } from '@/@types';
import { useEffect, useState } from 'react';
import { useUser } from '@/components/context/user';
import { useLocalizedLinks } from '@/components/core/hooks';
import { gql } from '@/services/api';
import { paginationToArray } from '@/services/api/namespaces/_utils';
import CarouselFeed from '@/components/core/components/organism/carousel/feed';
import * as styles from './recommendatinos.styles';
import Subtitle from '../subtitle';
import CategorySelector from './_components';
import * as queries from '../../home.queries';

const toFeed = (product: ProductType): FeedType => {
  return { product };
};

const Recommendations: UIComponent<{ products: ProductType[]; category: CategoryConstantType }> = ({ category, products }) => {
  const { api } = useUser();
  const [selectedCategory, setSelectedCategory] = useState(category);
  const [items, setItems] = useState<FeedType[]>(products.map(toFeed));
  const [loading, setIsLoading] = useState(false);
  const links = useLocalizedLinks();
  useEffect(() => {
    if (selectedCategory) {
      setIsLoading(true);
      api
        .graphqlRequest<{ Category: { get: CategoryType } }>({
          query: gql`
            ${queries.CategoryFragment}
            query Category($category: ID!) {
              Category {
                ...CategoryFragment
              }
            }
          `,
          variables: { category: selectedCategory.name },
        })
        .then((res) => {
          setItems(paginationToArray(res.data.Category.get.products).map(toFeed));
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  }, [api, selectedCategory]);

  return (
    <div className={styles.root}>
      <div className={styles.title}>
        <Subtitle>
          <Trans>The most recommended</Trans>
        </Subtitle>
        <p>
          <Trans>Discover the top recommendations of the moment✨</Trans>
        </p>
      </div>
      <CategorySelector selected={selectedCategory} onChange={setSelectedCategory} />
      <CarouselFeed items={items} loading={loading} seeMore={links.trending(selectedCategory)} />
    </div>
  );
};

export default Recommendations;
